import { useRouter } from "expo-router"

import { Box, Button, ButtonText, HStack, Text, VStack } from "wealthmode-frontend/gluestack/ui"

export default function Page500() {
  const router = useRouter()

  return (
    <div className="bg-background-primary min-h-screen flex items-center justify-center">
      <Box className="w-full max-w-md mx-auto px-4">
        <VStack className="items-center gap-6 text-center">
          <VStack className="gap-2">
            <Text className="text-8xl font-bold text-information-negative">500</Text>
            <Text className="text-2xl font-bold text-foreground-primary">Houston, we have a problem!</Text>
            <Text className="text-foreground-tertiary">The page you are looking for is temporarily unavailable.</Text>
          </VStack>
          <HStack className="gap-3">
            <Button
              action="secondary"
              variant="outline"
              onPress={() => router.back()}
            >
              <ButtonText>Go Back</ButtonText>
            </Button>
            <Button
              action="primary"
              className="bg-background-contrast"
              onPress={() => router.replace("/")}
            >
              <ButtonText className="text-foreground-contrast">Home</ButtonText>
            </Button>
          </HStack>
        </VStack>
      </Box>
    </div>
  )
}
